import React, { ReactNode } from "react"
import s from "./DefaultLayout.less"
import Sidebar from "../../components/Sidebar/Sidebar"
import { Route, Switch } from "react-router"
import { contentRoutes } from "../../Routes"
import SystemInfo from "../../components/SystemInfo/SystemInfo"

interface LayoutProps {
  children?: ReactNode
}

const DefaultLayout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className={s.root}>
      <SystemInfo />
      <div className={s.contentRoot}>
        <Switch>
          {contentRoutes.map(({ path, exact }) => (
            <Route key={""} path={path} exact={exact}>
              <Sidebar />
            </Route>
          ))}
        </Switch>
        <div className={s.content}>{children}</div>
      </div>
    </div>
  )
}

export default DefaultLayout
